export enum OutlookMobileContainer {
    ReadingPane,
    GetStarted,
    OpxHost,
    ExternalPartner
}
